/**
 * Records a REQUIRED FIELD becoming complete, once, where completion is what
 * unlocks the button. Not keystrokes: the threshold is the only interesting
 * moment, and on the address screen it is the only way to locate a drop inside
 * a screen with several fields.
 */
import { useEffect } from "react";
import { recordSignalOnce } from "@/lib/funnel-signals";
import type { FunnelState } from "@/lib/consumer-session";

export function useFieldCompletion(state: FunnelState, complete: boolean) {
  useEffect(() => {
    if (complete) recordSignalOnce(state);
  }, [state, complete]);
}
